import type { SysEmployeeDetailsDTO } from '@/dto/sys-employees/sys-employee-details.dto';
import { pipeAsync } from '@/lib/functions';
import { makeBinded } from '@/proxies';
import { httpService } from '@/services/http.service';
import { httpHeadersVO } from '@/vos/http/headers.vo';
import { sysEmployeesEndpointsVO } from '@/vos/sys-employees/endpoints.vo';
import type { Profile } from '@amministro-io-packages/auth-interfaces';

class SysEmployeesRepository {
  private readonly _http = httpService;
  private readonly _endpoints = sysEmployeesEndpointsVO;
  private readonly _headers = httpHeadersVO;

  async getOwn(profile: Profile) {
    return this._http.aGet<SysEmployeeDetailsDTO>(this._endpoints.findOwn({}), {
      headers: await pipeAsync(this._headers.autenticated, this._headers.json, this._headers.xAmministroProfile(profile))({}),
    });
  }
}

const sysEmployeesRepository = makeBinded(SysEmployeesRepository);

export { sysEmployeesRepository };
